/**
 * Resolve o valor de imagemPerfil para exibição em avatar.
 * - URL (http/https): retorna como src de imagem
 * - Texto (ex.: "ADM"): retorna como texto do avatar (iniciais/abreviação)
 * - Vazio ou nopicture: retorna null em ambos
 *
 * @param {string|null|undefined} cImagemPerfil
 * @returns {{ cUrlImagem: string|null, cTextoAvatar: string|null }}
 */
const resolverImagemPerfil = (cImagemPerfil) => {
  const cValor = typeof cImagemPerfil === "string" ? cImagemPerfil.trim() : cImagemPerfil

  if (!cValor || cValor === "null" || cValor === "undefined") {
    return { cUrlImagem: null, cTextoAvatar: null }
  }

  if (/nopicture\.png/i.test(cValor)) {
    return { cUrlImagem: null, cTextoAvatar: null }
  }

  const lEhUrlImagem =
    /^https?:\/\//i.test(cValor) ||
    /^blob:/i.test(cValor) ||
    /^data:image\//i.test(cValor) ||
    (cValor.startsWith("/") && /\.(jpe?g|png|gif|webp|bmp|svg)(\?.*)?$/i.test(cValor))

  if (lEhUrlImagem) {
    return { cUrlImagem: cValor, cTextoAvatar: null }
  }

  return { cUrlImagem: null, cTextoAvatar: cValor }
}

export default resolverImagemPerfil
